export const EVENTS = {
	DOWNLOAD_VIEW: 'Download App View',
	DOWNLOAD_TRIGGERED: 'Download Triggered',
	LOGIN_CODE_VALIDATE: 'Login Code Validate',
	LOG_IN_SUCCESS_VIEW: 'Log in Success View',
	DEEP_LINK_CLICKED: 'Deep Link Clicked',
	CHECKOUT_COMPLETED: 'Checkout Complete',
	CHECKOUT_STARTED: 'Checkout Started',
	CHECKOUT_LANDING: 'Checkout Landing',
	CHECKOUT_LANDING_NOT_AUTHENTICATED: 'Checkout Landing Not Authenticated',
	CHECKOUT_MERCHANT_EVENT: 'Checkout Merchant Event Received',
	SIGN_IN_VIEW: 'Sign In View',
	SIGN_IN_SELECT_CLICK: 'Sign In Select Click',
	SIGN_IN_ERROR: 'Sign in error',
	AUTOMATIC_DEEPLINK_TRIGGERED: 'Automatic Deeplink Triggered',
	WEBSOCKET_CONNECTED: 'Websocket connected',
	WEBSOCKET_DISCONNECTED: 'Websocket disconnected',
	ACTIVATION_EXPIRED_VIEW: 'Activation Expired View',
	DOWNLOAD_VM_SOUNDBOARD_VIEW: 'VMSoundboardApp Download Viewed',
	STORE_BUTTON_CLICKED: 'Store Button Clicked',
	STORE_BUTTON_CLICKED_SOUNDBOARDAPP: 'VMSoundboardApp Store Button Clicked',
	USER_ACCOUNT_VIEW: 'User Account View',
	CANCEL_SUBSCRIPTION_CLICKED: 'Cancel Subscription Clicked',
	SUBSCRIPTION_CANCELED: 'Subscription Cancelled',
	ACCOUNT_DELETED: 'Account Deleted',
	ACCOUNTS_WEB_CHECKCOUT_ERROR: 'Checkout Error',
	ACCOUNTS_WEB_UNEXPECTED_ERROR_OCCURRED:
		'Accounts Web Unexpected Error Occurred',
	PAGE_LOADING_TIME: 'Accounts Loading Time',
	PAGE_LOADING_CLICK: 'Accounts Loading Click',
	LEGACY_ROUTE_REDIRECTED: 'Legacy Route Redirected',
	AUTHORIZE_VIEW: 'Authorize View',
	CLIENT_AUTHORIZED: 'Client Authorized',
} as const;
